import { formEncode, handleResponse, nextJsonApi } from '@/API/core';

const reportError = {
  report: async (data: any) => {
    let response = null;
    try {
      response = await nextJsonApi.post(`/report-error`, formEncode(data));
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
};

export default reportError;
